










import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { ImagePreview } from 'vant'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 点击触发
      handleClick = (e: any) => {
        if (e.target.tagName === 'IMG') {
          ImagePreview({
            images: [e.target.src],
          })
        }
      }
    },
)
